import './customer-details';
import './customer-info';
import './downloads';
import './inline-container';
import './order-details';
import './order-info';
import './thank-you-block';
